<template>
<div>
  <div class="header">
    <img class="logo" src="../../public/image/index/216.png">
    <div class="header-content">
      <div class="header-title">CC加速器</div>
      <div class="header-describe">免费 稳定 极速</div>
    </div>
    <img class="header-download"  src="../../public/image/index/98.png" @click="downloadAPK">
  </div>
  <div class="navigation">
    <img @click="historyGo" class="navigation-img" src="../../public/image/index/99.png">
    <div class="navigation-txt">官网如何下载cc加速器教程</div>
  </div>
  <div class="principal">
    <div class="principal_content step">亲爱的CC玩家们</div>
    <div class="principal_content matter">在部分手机品牌的应用商店，例如：OPPO、VIVO、小米等，下载的CC加速器暂时无法提供游戏下载和更新功能。如需用到下载/更新游戏的用户可点击下方链接进入CC加速器官网进行下载</div>

    <div class="principal-headline2" @click="openOfficial">CC加速器官网入口</div>
    <img class="principal-img-1" src="../../public/image/index/100.png">

    <div class="principal-hint headline">
      <img class="principal-hint-icon" src="../../public/image/index/01.png">
      <div class="principal-hint-txt">温馨提示：</div>
    </div>

    <div class="principal_content">进入官网点击下载后要选择源文件进行下载（VIVO手机为例）</div>
    <img class="principal-img-1" src="../../public/image/index/101.png">
  </div>
</div>
</template>

<script>
export default {
  name: 'Help_02',
  methods: {
    downloadAPK () {
      window.location.href = 'https://resource.ccspeed.cn/prd/42/20210409/47bfa20b-31fa-4008-9620-5adda1dab2ee.apk'
    },
    openOfficial () {
      window.location.href = 'https://m.ccspeed.cn/'
    },
    historyGo () {
      history.go(-1)
    }
  }
}
</script>
<style>
body{
  background: #161922;
}
*{
  font-family: Source Han Sans CN;
}
</style>
<style scoped lang="scss">
.header{
  height: 60px;
  background: #161922;
  display: flex;
  align-items: center;
  .logo{
    width: 42px;
    height: 42px;
    margin-left: 14px;
    margin-right: 7px;
  }
  .header-content{
    width: 220px;
    .header-title{
      font-size: 15px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #FFFFFF;
      margin-bottom: 2px;

      background: linear-gradient(0deg, #2992FF 0%, #00F2C2 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
    .header-describe{
      font-size: 11px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #FFFFFF;
    }
  }
  .header-download{
    width: 70px;
    height: 28px;
    position: absolute;
    right: 14px;
  }
}
.navigation{
  height: 44px;
  background: #202632;
  display: flex;
  align-items: center;
  .navigation-img{
    width: 35px;
    height: 35px;
    border-radius: 50%;
    margin-left: 14px;
    margin-right: 10px;
  }
  .navigation-txt{
    font-size: 14px;
    font-weight: 400;
    color: #F1F1F1;
  }
}
.principal{
  margin-top: 20px;
  padding: 13px;
  padding-top: 0;
  font-size: 14px;
  line-height: 21px;
  .principal-headline1{
    font-weight: 500;
    color: #F1F1F1;
  }
  .principal_content{
    font-weight: 400;
    color: #68829E;
    margin-top: 17px;
    .principal_content-blue{
      color: #2992FF;
    }
  }
  .matter{
    line-height: 21px;
  }
  .step{
    color: #F1F1F1;
  }
  .principal-headline2{
    font-weight: 400;
    color: #2992FF;
    margin-top: 15px;
    line-height: 19px;
  }
  .principal-img-1{
    margin-top: 17px;
    width: 100%;
  }
  .principal-hint{
    margin-top: 18px;
    display: flex;
    align-items: center;
    .principal-hint-icon{
      width: 9px;
      height: 8px;
    }
    .principal-hint-txt{
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #68829E;
      margin-left: 4px;
    }
  }
}
.headline{
  line-height: 19px;
}
</style>
